
import store from "@/store/index";
/*转换*/
export function transferParams2Str(obj) {
    let str = '?';
    Object.keys(obj).forEach(key => {
        str += `${key}=${obj[key]}&`;
    });
    return str.substring(0, str.length - 1);
}

export function downloadFile(url, fileName = '导出',options={}) {
    const type = options.type||'POST';
    const xhr = new XMLHttpRequest();
    const token = store.getters.getToken;

    xhr.open(type, url, true);

    xhr.setRequestHeader("Authorization", token);
    xhr.setRequestHeader("JT_S_01_2_token", token);
    xhr.responseType = 'blob';
    console.log('xhr创建成功', xhr);
    console.log("携带token为：",token);

    xhr.onload = function (e) {
        console.log('e==>', e);

        //如果请求执行成功
        if (this.status == 200) {
            var blob = this.response;
            var a = document.createElement('a');
            // blob.type = "application/octet-stream";
            //创键临时url对象
            var url = URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            //释放之前创建的URL对象
            window.URL.revokeObjectURL(url);
        }
    }
    xhr.onerror = e=>{
        console.log("加载失败，原因：",e)
    }
    xhr.send();
}



// WEBPACK FOOTER //
// ./src/utils/index.js